// extracted by mini-css-extract-plugin
module.exports = {"PhotoCropInput":"bfq_a","ReactCrop--disabled":"bfq_b","ReactCrop--circular-crop":"bfq_c"};